module.exports = __webpack_public_path__ + "static/media/group_trainings_mind_body_fitness.e440163d.webp";